import { initErrorMonitor } from '../configs/errorMonitor';

import { uuidV1 } from './uuid';

export const setupErrorMonitor = () => {
    try {
        // 这里可以从用户登录信息中获取用户ID
        const userId = window.adv ? window.adv.getAdvUUID() : uuidV1();

        initErrorMonitor(userId);

        // 监听全局未捕获的错误
        window.addEventListener('error', (event) => {
            console.error('Uncaught error:', event.error);
        });

        // 监听Promise中未捕获的错误
        window.addEventListener('unhandledrejection', (event) => {
            console.error('Unhandled promise rejection:', event.reason);
        });
    } catch (e) {
        console.error('Error initializing error monitor:', e);
    }
};
